import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'auth',
    loadComponent: () =>
      import('./features/auth/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shared/components/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent
      ),
    children: [
      {
        path: '',
        redirectTo: 'ventas',
        pathMatch: 'full',
      },
      {
        path: 'ventas',
        loadComponent: () =>
          import(
            './features/ventas/pages/listado-ventas/listado-ventas.component'
          ).then((m) => m.ListadoVentasComponent),
      },
      {
        path: 'vender',
        loadComponent: () =>
          import(
            './features/ventas/pages/formulario-venta/formulario-venta.component'
          ).then((m) => m.FormularioVentaComponent),
      },
      {
        path: 'leads',
        loadComponent: () =>
          import(
            './features/leads/pages/listado-leads/listado-leads.component'
          ).then((m) => m.ListadoLeadsComponent),
      },
      {
        path: 'crear-lead',
        loadComponent: () =>
          import(
            './features/leads/pages/registro-leads/registro-lead.component'
          ).then((m) => m.RegistroLeadComponent),
      },
      {
        path: 'formulario-lead/:id',
        loadComponent: () =>
          import(
            './features/leads/pages/formulario-leads/formulario-lead.component'
          ).then((m) => m.FormularioLeadComponent),
      },
      {
        path: 'gestion/:id',
        loadComponent: () =>
          import(
            './features/leads/pages/gestion-leads/lead-gestion.component'
          ).then((m)=> m.LeadGestionComponent)
      },
      {
        path: 'modulo',
        loadComponent: () =>
          import(
            './features/ventas/pages/modulo-ventas/modulo-ventas.component'
          ).then((m) => m.ModuloVentasComponent),
      },
      {
        path: 'reporte',
        loadComponent: () =>
          import(
            './features/ventas/pages/reporte-ventas/reporte-ventas.component'
          ).then((m) => m.ReporteVentasComponent),
      },
      {
        path: 'validaciones',
        children: [
          {
            path: 'preventa/:id',
            loadComponent: () =>
              import(
                './features/validaciones/pages/validacion-preventa/validacion-preventa.component'
              ).then((m) => m.ValidacionPreventaComponent),
          },
          {
            path: 'postventa/:id',
            loadComponent: () =>
              import(
                './features/validaciones/pages/validacion-postventa/validacion-postventa.component'
              ).then((m) => m.ValidacionPostventaComponent),
          },
        ],
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
  },
];
